import React from 'react';
import { message, Popconfirm } from 'antd';
import { useDispatch } from "react-redux";
import { deleteEvent } from "../../../redux/Event/actions";

function DeleteEventButton({ item }) {
    const dispatch = useDispatch();

    const deleteEvent_fun = () => {    
        dispatch(deleteEvent(item._id));
        message.success("Deleted");    
    };

    const confirm = () => {
        deleteEvent_fun();
    };

    const cancel = () => {
        // Optionally handle cancel action
    };

    return (
        <Popconfirm
            onConfirm={confirm}
            onCancel={cancel}
            title="Êtes-vous sûr de vouloir supprimer ?"
            okText="Oui"
            cancelText="Non"
        >
            <a>Delete</a>
        </Popconfirm>
    );
}

export default DeleteEventButton;
